"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configureStore = configureStore;

var _redux = require("redux");

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _logger = require("../middleware/logger");

var _logger2 = _interopRequireDefault(_logger);

var _analytics = require("../middleware/analytics");

var _analytics2 = _interopRequireDefault(_analytics);

var _api = require("../middleware/api");

var _api2 = _interopRequireDefault(_api);

var _metrics = require("../middleware/metrics");

var _metrics2 = _interopRequireDefault(_metrics);

var _plugin = require("../middleware/plugin");

var _plugin2 = _interopRequireDefault(_plugin);

var _stripeToken = require("../middleware/stripeToken");

var _stripeToken2 = _interopRequireDefault(_stripeToken);

var _asyncDispatch = require("../middleware/asyncDispatch");

var _asyncDispatch2 = _interopRequireDefault(_asyncDispatch);

var _ravenRedux = require("../middleware/ravenRedux");

var _ravenRedux2 = _interopRequireDefault(_ravenRedux);

var _reducers = require("../reducers");

var _reducers2 = _interopRequireDefault(_reducers);

var _fluxCompatibility = require("./flux-compatibility");

var _fluxCompatibility2 = _interopRequireDefault(_fluxCompatibility);

var _reduxWindowsize = require("redux-windowsize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(preloadedState) {
    var middlewares = [_reduxThunk2.default, _api2.default, _plugin2.default, _analytics2.default, _stripeToken2.default, _metrics2.default, _asyncDispatch2.default, _ravenRedux2.default];

    if (process.env.NODE_ENV !== "production") {
        middlewares.push(_logger2.default);
    }

    var store = (0, _redux.createStore)(_reducers2.default, preloadedState, _redux.applyMiddleware.apply(undefined, middlewares));

    (0, _fluxCompatibility2.default)(store.dispatch);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept("../reducers", function () {
            var nextReducer = require("../reducers").default;
            store.replaceReducer(nextReducer);
        });
    }

    // Update redux with current size.
    store.dispatch((0, _reduxWindowsize.createSizeAction)(window));
    // Dispatch an action every 100ms when window size changes.
    (0, _reduxWindowsize.listenResize)(store, window, 100);

    return store;
}

exports.default = configureStore();